import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import Navbar from '../navbar';
import Colors from '../pages/colors';
import tictactoe from '../pages/tictactoe';

import './AppRouter.scss';

const AppRouter = () => (
  <Router>
    <>
      <Navbar />
      <div className="container">
        <Switch>
          <Route exact path="/colors" component={Colors} />
          <Route exact path="/tictactoe" component={tictactoe} />
          <Route exact path="/" component={Colors} />
        </Switch>
      </div>
    </>
  </Router>
);

export default AppRouter;
